import { bytesToNDigits } from '@mail/cross-sizes-utils';
import type { ProductsListResponse } from 'reactApp/api/billing/products/ProductsAPICall.types';
import { SPACE_LIST } from 'reactApp/constants/spaceList';
import type { NormalizedList } from 'reactApp/modules/productsList/productsList.types';

export const normalizeProducts = (rawList: ProductsListResponse): NormalizedList => {
    const list: NormalizedList = {};

    Object.keys(rawList).forEach((id) => {
        const product = rawList[id];

        const { buy, discount, trial, resources } = product;

        const { prices, services } = resources?.cloud || {};

        const space = bytesToNDigits(services?.cloud?.quota || 0, 3);

        list[id] = {
            id,
            available: buy?.available,
            price: prices?.cost,
            period: prices?.interval,
            hasTrial: Boolean(trial),
            trialPeriod: trial?.interval,
            hasDiscount: Boolean(discount),
            discountPrice: prices?.discount_cost,
            discountPeriod: discount?.interval,
            discountPeriodCount: discount?.interval_count,
            space,
            isForceDiscountTrial: Boolean(discount) && trial?.type === 'force',
            isFamily: services?.common?.family,
            isOnlyFeatures: space.original === SPACE_LIST.kb_1,
        };
    });

    return list;
};
